<template>
  <a
    v-if="documentUrl"
    class="underline hover:no-underline"
    :href="documentUrl"
    target="_blank"
    >{{ $texts('product.sizeguideLink') }}</a
  >
  <NuxtLink
    v-else-if="nodeId || imageUrl"
    class="underline hover:no-underline"
    :to="{
      query: { ...route.query, view: 'sizeguide' },
    }"
    >{{ $texts('product.sizeguideLink') }}</NuxtLink
  >

  <Teleport to="body">
    <Transition name="overlay">
      <ProductSizeguideView
        v-if="sizeguideVisible"
        :node-id="nodeId"
        :image-url="imageUrl"
        @close="closeOverlay"
      />
    </Transition>
  </Teleport>
</template>

<script lang="ts" setup>
import type { ProductSizeguideEntityFragment } from '#build/graphql-operations'

const props = defineProps<{
  sizeguide?: ProductSizeguideEntityFragment
}>()

const route = useRoute()
const router = useRouter()
const sizeguideVisible = computed(() => route.query.view === 'sizeguide')

const documentUrl = computed(() =>
  props.sizeguide && 'documentUrl' in props.sizeguide
    ? props.sizeguide.documentUrl?.path
    : undefined,
)

const imageUrl = computed(() =>
  props.sizeguide && 'imageUrl' in props.sizeguide
    ? props.sizeguide.imageUrl?.path
    : undefined,
)

const nodeId = computed(() =>
  props.sizeguide && 'id' in props.sizeguide ? props.sizeguide.id : undefined,
)

const closeOverlay = () =>
  router.replace({ query: { ...route.query, view: undefined } })

defineOptions({
  name: 'ProductSizeguide',
})
</script>
